<template>
  <LayoutTelas
    id="tela__filtros"
    :titulo="titulo">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />

    <b-input-group>
      <b-form-input
        name="filtro"
        v-focus
        placeholder="Pesquisar"
        v-model="formFiltro.filtroValue"
        v-validate="'required|min:2'"
        :state="errors.has('filtro') ? false : null"
        autocomplete="off"
      />
      <b-input-group-append>
        <b-button
          variant="outline-primary"
          @click="buscaFiltro(formFiltro.filtroValue)">
          Filtrar
        </b-button>

        <b-button
          variant="primary"
          @click="buscarTodos">
          Todos
        </b-button>
      </b-input-group-append>

      <b-form-invalid-feedback id="filtroFeedback">
        {{ errors.first('filtro') }}
      </b-form-invalid-feedback>
    </b-input-group>

    <b-table
      v-if="temRegistrosListar"
      stacked="sm"
      striped
      hover
      :sort-by.sync="ordenarPor"
      :sort-desc.sync="sortDesc"
      :items="registros"
      :fields="camposTabela"
      @row-clicked="clicouItemTabela">

      <template
        v-for="item in camposMascaraValor"
        :slot="item"
        slot-scope="data">
        {{data.value | currency}}
      </template>

      <template
        v-for="item in camposMascaraData"
        :slot="item"
        slot-scope="data">
        {{retornaDataFormatadaTabelaConsulta(data.value)}}
      </template>

      <template
        v-for="botao in arrBotoesAcao"
        :slot="botao.slot"
        slot-scope="data">
        <BButton
          v-if="mostrarBotao(data.item, botao)"
          v-bind:key="botao._id"
          size="sm"
          @click="acaoBotaoTabela(data.item, botao)"
          :variant="botao.variant">
          <v-icon
            scale="1.3"
            :name="botao.icone"
            class="iconButton"/>
        </BButton>
      </template>

    </b-table>

    <div class="paginacao"
      v-if="temRegistrosListar && (totalPaginas > 1)">
      <b-pagination
        class="paginacao__seletor"
        :total-rows="totalPaginas"
        :per-page="paginacao.limitePorPagina"
        v-model="paginacao.paginaAtual"
        @input="mudarPagina"
        size="sm"
      />
    </div>
  </LayoutTelas>
</template>

<script>
import * as moment from 'moment'
import bPagination from 'bootstrap-vue/es/components/pagination/pagination'
import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group'
import bInputGroupAppend from 'bootstrap-vue/es/components/input-group/input-group-append'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import bFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'
import bTable from 'bootstrap-vue/es/components/table/table'
import bButton from 'bootstrap-vue/es/components/button/button'
import FieldFocus from '@/mixins/FieldFocus'

export default {
  props: {
    titulo: {
      type: String,
      required: true,
    },
    camposTabela: {
      required: true,
    },
    ordenarPor: {
      type: String,
      required: true,
    },
    registros: {
      type: Array,
      required: true,
      default: () => [],
    },
    totalPaginas: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    camposMascaraValor: {
      type: Array,
      default: function () {
        return []
      },
    },
    camposMascaraData: {
      type: Array,
      default: function () {
        return []
      },
    },
    arrBotoesAcao: {
      /*
        O array recebe um objeto com a estrutura a seguir
        {
          _id: 'topperson',
          slot: 'faustop',
          variant: 'success',
          icone: 'times',
          mostrar: function
        }
      */
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data() {
    return {
      formFiltro: {
        filtroValue: '',
      },
      paginacao: {
        paginaAtual: 1,
        limitePorPagina: 1,
      },
      sortDesc: false,
    }
  },
  components: {
    bInputGroup,
    bInputGroupAppend,
    bFormInput,
    bFormInvalidFeedback,
    bTable,
    bButton,
    bPagination,
  },
  mixins: [FieldFocus],
  computed: {
    temRegistrosListar() {
      return this.registros.length > 0
    },
  },
  methods: {
    limpar(resetarPaginacao = false) {
      if (resetarPaginacao) {
        this.paginacao.paginaAtual = 1
      }

      this.errors.clear()
      this.$emit('limpar')
    },
    buscarTodos(pagina = 0, resetarPaginacao = true) {
      this.limpar(resetarPaginacao)
      this.$emit('buscarTodos', pagina)
    },
    buscaFiltro(filtro, pagina = 0, resetarPaginacao = true) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.limpar(resetarPaginacao)
          this.$emit('buscaFiltro', filtro, pagina)
        }
      })
    },
    clicouItemTabela(item) {
      this.$emit('clicouItemTabela', item)
    },
    mudarPagina() {
      if (this.formFiltro.filtroValue !== '') {
        this.buscaFiltro(this.formFiltro.filtroValue, this.paginacao.paginaAtual, false)
      } else {
        this.buscarTodos(this.paginacao.paginaAtual, false)
      }
    },
    acaoBotaoTabela(item, botaoColuna) {
      botaoColuna.acao(item)
    },
    mostrarBotao(item, botaoColuna) {
      return botaoColuna.mostrar(item)
    },
    retornaDataFormatadaTabelaConsulta(string) {
      try {
        if (!string) {
          return ''
        }

        const data = moment(string).add(-3, 'hours')
        return data.utc().format('DD/MM/YYYY HH:mm:ss')
      } catch {
        return ''
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__filtros {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.paginacao {
  display: flex;
  justify-content: flex-end;

  &__seletor {
    margin: 0;
  }
}
</style>
